/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComunicazioneOutboxStato } from './comunicazione-outbox-stato';
import { EventoTipoPratica } from './evento-tipo-pratica';
import { CanaleComunicazione } from './canale-comunicazione';


export interface PraticaComunicazioneEsitoDTO { 
    evento?: EventoTipoPratica;
    canale?: CanaleComunicazione;
    stato?: ComunicazioneOutboxStato;
    tentativi?: number;
    inviata_at?: string;
    chiusa_at?: string;
    next_attempt_at?: string;
    created_at?: string;
}



